/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type Event,
    EventFromJSON,
    EventToJSON,
} from '../models/Event';
import {
    type EventKind,
    EventKindFromJSON,
    EventKindToJSON,
} from '../models/EventKind';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';

export interface EventsListEventsRequest {
    pageSize: number;
    search?: string | null;
    eventKinds?: Array<EventKind> | null;
    page?: number | null;
}

export interface EventsListEventsMetadataRequest {
    pageSize: number;
    search?: string | null;
    eventKinds?: Array<EventKind> | null;
}

/**
 * EventsApi - interface
 * 
 * @export
 * @interface EventsApiInterface
 */
export interface EventsApiInterface {
    /**
     * Creates request options for eventsListEvents without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<EventKind>} [eventKinds] 
     * @param {number} [page] 
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    eventsListEventsRequestOpts(requestParameters: EventsListEventsRequest): Promise<runtime.RequestOpts>;

    /**
     * List generic events consisting of shock events, badge zone violations, and vehicle zone violations.
     * @summary List events
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<EventKind>} [eventKinds] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    eventsListEventsRaw(requestParameters: EventsListEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>>;

    /**
     * List generic events consisting of shock events, badge zone violations, and vehicle zone violations.
     * List events
     */
    eventsListEvents(requestParameters: EventsListEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>>;

    /**
     * Creates request options for eventsListEventsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<EventKind>} [eventKinds] 
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    eventsListEventsMetadataRequestOpts(requestParameters: EventsListEventsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Event listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<EventKind>} [eventKinds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    eventsListEventsMetadataRaw(requestParameters: EventsListEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Event listing metadata
     */
    eventsListEventsMetadata(requestParameters: EventsListEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI implements EventsApiInterface {

    /**
     * Creates request options for eventsListEvents without sending the request
     */
    async eventsListEventsRequestOpts(requestParameters: EventsListEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling eventsListEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['eventKinds'] != null) {
            queryParameters['event_kinds'] = requestParameters['eventKinds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/events/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List generic events consisting of shock events, badge zone violations, and vehicle zone violations.
     * List events
     */
    async eventsListEventsRaw(requestParameters: EventsListEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>> {
        const requestOptions = await this.eventsListEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFromJSON));
    }

    /**
     * List generic events consisting of shock events, badge zone violations, and vehicle zone violations.
     * List events
     */
    async eventsListEvents(requestParameters: EventsListEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>> {
        const response = await this.eventsListEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eventsListEventsMetadata without sending the request
     */
    async eventsListEventsMetadataRequestOpts(requestParameters: EventsListEventsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling eventsListEventsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['eventKinds'] != null) {
            queryParameters['event_kinds'] = requestParameters['eventKinds'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/events/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Event listing metadata
     */
    async eventsListEventsMetadataRaw(requestParameters: EventsListEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.eventsListEventsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Event listing metadata
     */
    async eventsListEventsMetadata(requestParameters: EventsListEventsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.eventsListEventsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
